module.exports = __webpack_public_path__ + "static/img/39840.911f49f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/39840.jpg
// module id = i9WI
// module chunks = 1